import { createContext, useContext } from 'react';

/** { actifSecteurId, actifCompanyId } — null si pas encore chargé */
export const AppSecteurScopeContext = createContext(null);

export function useAppSecteurScope() {
  return useContext(AppSecteurScopeContext);
}
